import React, { useState, useRef } from "react";
import jsPDF from "jspdf";
import statesAndDistricts from "./../../../data/statesAndDistricts.json";

const NewPanApplication = () => {
  const [hideRA, setHideRA] = useState(false);
  const [formData, setFormData] = useState({
      AreaCode: "",
      AoType: "",
      RangeCode: "",
      AONo: "",
      state: "",
      district: "",
      category: "",
      ApplicantCheckedOption: "",
      LastName: "",
      FirstName: "",
      MiddleName: "",
      NewPanName: "",
      FatherLastName: "",
      FatherFirstName: "",
      FatherMiddleName: "",
      MotherLastName: "",
      MotherFirstName: "",
      MotherMiddleName: "",
      Dob: "",
      ISDCode: "",
      STDCode: "",
      MobileNo: "",
      EmailId: "",
      AadharName: "",
      PanDispatchState: "",
      Aadhar_EID: "",
      RAAddress: "",
      IdentityProof: "",
      AddressProof: "",
      DobProof: "",
      ResidentRoom: "",
      ResidentPremises: "",
      ResidentStreet: "",
      ResidentArea: "",
      ResidentCity: "",
      ResidentState: "",
      ResidentPinCode: "",
      OfficeName:"",
      OfficeRoom: "",
      OfficePremises: "",
      OfficeStreet: "",
      OfficeArea: "",
      OfficeCity: "",
      OfficeState: "",
      OfficePinCode: "",
      RepresentativeCheckedOption: "",
      RepresentativeLastName: "",
      RepresentativeFirstName: "",
      RepresentativeMiddleName: "",
      RepresentativeRoom: "",
      RepresentativePremises: "",
      RepresentativeStreet: "",
      RepresentativeArea: "",
      RepresentativeCity: "",
      RepresentativeState: "",
      RepresentativePinCode: "",
      pdfDocument: null,  // File
      photo: null,        // File
      signature: null,    // File
  
  });

  const pdfDocumentRef = useRef(null);
  const photoRef = useRef(null);
  const signatureRef = useRef(null);

  const formatDateToString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`; // Format: dd/MM/yyyy
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    const section = event.target.closest(".applicant-section")
      ? "ApplicantCheckedOption"
      : "RepresentativeCheckedOption";
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      [section]: name,
    }));
  };

  
    const [errors, setErrors] = useState({
      Aadhar_EID: ""
    });
    const aadharRegex = /^[2-9]{1}[0-9]{11}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
   // let newValue = value;

    // Pincode limit to 6 digits
  if (name === "ResidentPinCode" || name === "OfficePinCode" || name === "RepresentativePinCode") {
    const digitsOnly = value.replace(/\D/g, "");
    if (digitsOnly.length > 6) return; // block after 6 digits
    setFormData({ ...formData, [name]: digitsOnly });
    return;
  }

  // DOB age check (<18 hides RA fields)
  if (name === "Dob") {
    const selectedDate = new Date(value);
    const today = new Date();
    let age = today.getFullYear() - selectedDate.getFullYear();
    const m = today.getMonth() - selectedDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < selectedDate.getDate())) {
      age--;
    }
    if (age < 18) {
      setFormData(prev => ({
        ...prev,
        Dob: value,
        RepresentativeCheckedOption: "",
        RepresentativeLastName: "",
        RepresentativeFirstName: "",
        RepresentativeMiddleName: ""
      }));
      setHideRA(true); // you can add a state to conditionally render RA fields
    } else {
      setHideRA(false);
      setFormData({ ...formData, Dob: value });
    }
    return;
  }

  
  
    // Aadhaar: digits only, max 12, validate
    if (name === "Aadhar_EID") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length > 12) return;
  
      setFormData({ ...formData, [name]: digitsOnly });
  
      // Aadhaar validation (if regex is defined)
      if (digitsOnly.length === 12 && !aadharRegex.test(digitsOnly)) {
        setErrors((prev) => ({
          ...prev,
          Aadhar_EID: "Invalid Aadhaar number. Must be 12 digits and start from 2–9.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, Aadhar_EID: "" }));
      }
      return;
    }  
    //setFormData({ ...formData, [name]: newValue });
    setFormData({ ...formData, [name]: value });
  };
  

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
  
    // Log the selected file
    console.log(`Selected file for ${name}:`, file);
  
    // Validation based on input name
    if (file) {
      const fileType = file.type;
  
      // PDF validation
      if (name === "pdfDocument" && fileType !== "application/pdf") {
        alert("Only PDF files are allowed.");
        e.target.value = ""; // Clear input
        return;
      }
  
      // Image validation for photo and signature
      if ((name === "photo" || name === "signature") &&
          !(fileType === "image/jpeg" || fileType === "image/png")) {
        alert("Only JPG and PNG files are allowed.");
        e.target.value = ""; // Clear input
        return;
      }
    }
  
    // If valid, update state
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };
 

  const [disableNames, setDisableNames] = useState(false);
  const handleCategoryChange = (e) => {
    const selectedOption = e.target.value;
    setFormData((prev) => ({ ...prev, category: selectedOption }));
  
    const disableOptions = [
      "Trust",
      "Hindu Undivided Family",
      "Partnership Firm",
      "Association Of Person",
      "Body Of Individuals Individuals",
    ];
    setDisableNames(disableOptions.includes(selectedOption));
  };


  const handleSubmitNewPan = async (event) => {
  event.preventDefault();

   const proceed = window.confirm("Do you want to submit? \n Press OK to confirm or Cancel to stay on page.");
  if (!proceed) return;

  try {
    // ✅ Step 1: Submit Main Application Data
    const applicationFormData = new FormData();
    applicationFormData.append("AreaCode", formData.AreaCode);
    applicationFormData.append("AOType", formData.AoType);
    applicationFormData.append("RangeCode", formData.RangeCode);
    applicationFormData.append("AOCode", formData.AONo);
    applicationFormData.append("State", formData.state);
    applicationFormData.append("District", formData.district);
    applicationFormData.append("ApplicantType", formData.category);
    applicationFormData.append("ApplicantCheckedOption", formData.ApplicantCheckedOption);
    applicationFormData.append("LastName", formData.LastName);
    applicationFormData.append("FirstName", formData.FirstName);
    applicationFormData.append("MiddleName", formData.MiddleName);
    applicationFormData.append("NewPanName", formData.NewPanName);
    applicationFormData.append("FatherLastName", formData.FatherLastName);
    applicationFormData.append("FatherFirstName", formData.FatherFirstName);
    applicationFormData.append("FatherMiddleName", formData.FatherMiddleName);
    applicationFormData.append("MotherLastName", formData.MotherLastName);
    applicationFormData.append("MotherFirstName", formData.MotherFirstName);
    applicationFormData.append("MotherMiddleName", formData.MotherMiddleName);
    applicationFormData.append("Date", formatDateToString(formData.Dob));
    applicationFormData.append("ISDCode", formData.ISDCode);
    applicationFormData.append("STDCode", formData.STDCode);
    applicationFormData.append("MobileNo", formData.MobileNo);
    applicationFormData.append("EmailId", formData.EmailId);
    applicationFormData.append("AadharName", formData.AadharName);
    applicationFormData.append("PanDispatchState", formData.PanDispatchState);
    applicationFormData.append("Aadhar_EID", formData.Aadhar_EID);
    applicationFormData.append("RAAddress", formData.RAAddress);
    applicationFormData.append("IdentityProof", "AadhaarCard");
    applicationFormData.append("AddressProof", "AadhaarCard");
    applicationFormData.append("DobProof", "AadhaarCard");
    applicationFormData.append("ResidentRoom", formData.ResidentRoom);
    applicationFormData.append("ResidentPremises", formData.ResidentPremises);
    applicationFormData.append("ResidentStreet", formData.ResidentStreet);
    applicationFormData.append("ResidentArea", formData.ResidentArea);
    applicationFormData.append("ResidentCity", formData.ResidentCity);
    applicationFormData.append("ResidentState", formData.ResidentState);
    applicationFormData.append("ResidentPinCode", formData.ResidentPinCode);
    applicationFormData.append("RepresentativeCheckedOption", formData.RepresentativeCheckedOption);
    applicationFormData.append("RepresentativeLastName", formData.RepresentativeLastName);
    applicationFormData.append("RepresentativeFirstName", formData.RepresentativeFirstName);
    applicationFormData.append("RepresentativeMiddleName", formData.RepresentativeMiddleName);
    applicationFormData.append("RepresentativeRoom", formData.RepresentativeRoom);
    applicationFormData.append("RepresentativePremises", formData.RepresentativePremises);
    applicationFormData.append("RepresentativeStreet", formData.RepresentativeStreet);
    applicationFormData.append("RepresentativeArea", formData.RepresentativeArea);
    applicationFormData.append("RepresentativeCity", formData.RepresentativeCity);
    applicationFormData.append("RepresentativeState", formData.RepresentativeState);
    applicationFormData.append("RepresentativePinCode", formData.RepresentativePinCode);
    applicationFormData.append("OfficeName", formData.OfficeName);
    applicationFormData.append("OfficeRoom", formData.OfficeRoom);
    applicationFormData.append("OfficePremises", formData.OfficePremises);
    applicationFormData.append("OfficeStreet", formData.OfficeStreet);
    applicationFormData.append("OfficeArea", formData.OfficeArea);
    applicationFormData.append("OfficeCity", formData.OfficeCity);
    applicationFormData.append("OfficeState", formData.OfficeState);
    applicationFormData.append("OfficePinCode", formData.OfficePinCode);
    applicationFormData.append("PdfDocument", formData.pdfDocument);
    applicationFormData.append("Photo", formData.photo);
    applicationFormData.append("Signature", formData.signature); 

    const authToken = localStorage.getItem("authToken"); 

    console.log("Submitting FormData to API...");
    // ✅ Debugging - Log all FormData entries
    for (let pair of applicationFormData.entries()) {
    console.log(pair[0], pair[1], pair[1] instanceof File ? pair[1].name : "");
    }

    //const response = await fetch("http://localhost:5121/api/NewPanApplication/NewPanApplication", {
    const response = await fetch("https://apiv2.chakran.in/api/NewPanApplication/NewPanApplication", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: applicationFormData
    });

    const result = await response.json();

    if (!response.ok) {
     // Show the actual message returned by the API
     const errorMessage = result.message || result.Message || "Failed to submit application data.";
     alert(errorMessage);
      return; // Stop further execution
     //throw new Error(errorMessage); // Optional, in case you want to log it as well
    }

    
    console.log("Application Submitted:", result);
    // Trigger balance update
    window.dispatchEvent(new Event("balanceUpdated"));
    setFormData({
      AreaCode: "",
      AoType: "",
      RangeCode: "",
      AONo: "",
      state: "",
      district: "",
      category: "",
      ApplicantCheckedOption: "",
      LastName: "",
      FirstName: "",
      MiddleName: "",
      NewPanName: "",
      FatherLastName: "",
      FatherFirstName: "",
      FatherMiddleName: "",
      MotherLastName: "",
      MotherFirstName: "",
      MotherMiddleName: "",
      Dob: "",
      ISDCode: "",
      STDCode: "",
      MobileNo: "",
      EmailId: "",
      AadharName: "",
      PanDispatchState: "",
      Aadhar_EID: "",
      RAAddress: "",
      IdentityProof: "",
      AddressProof: "",
      DobProof: "",
      ResidentRoom: "",
      ResidentPremises: "",
      ResidentStreet: "",
      ResidentArea: "",
      ResidentCity: "",
      ResidentState: "",
      ResidentPinCode: "",
      OfficeName:"",
      OfficeRoom: "",
      OfficePremises: "",
      OfficeStreet: "",
      OfficeArea: "",
      OfficeCity: "",
      OfficeState: "",
      OfficePinCode: "",
      RepresentativeCheckedOption: "",
      RepresentativeLastName: "",
      RepresentativeFirstName: "",
      RepresentativeMiddleName: "",
      RepresentativeRoom: "",
      RepresentativePremises: "",
      RepresentativeStreet: "",
      RepresentativeArea: "",
      RepresentativeCity: "",
      RepresentativeState: "",
      RepresentativePinCode: "",
      pdfDocument: null,  // File
      photo: null,        // File
      signature: null,    // File
  
  });

  // Reset actual file inputs
  if (pdfDocumentRef.current) pdfDocumentRef.current.value = "";
  if (photoRef.current) photoRef.current.value = "";
  if (signatureRef.current) signatureRef.current.value = "";

  alert("Form submitted successfully!");
  window.location.href = "/dashboard";

  } catch (error) {
    console.error("While submitting form something went wrong. Please try again.");
    if (typeof error.message === "string") {
      alert(error.message);
    } else {
      alert("An unexpected error occurred. Please try again.");
    }
  } 
  

  //for pdf
  const doc = new jsPDF();

  // Draw a border around the entire PDF
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;


  // Function to draw border on the current page
const drawBorder = () => {
  
  doc.setDrawColor(0, 0, 0); // Set border color to black
  doc.rect(5, 5, pageWidth - 10, pageHeight - 10); // Draw border with a 5px margin
};

  // Title
  drawBorder();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  const title = "Form No. 49A";
  const titleWidth = doc.getTextWidth(title);
  const centerX = (pageWidth - titleWidth) / 2;
  doc.text(title, centerX, 10);

  // Adjusted Y position for boxes (move them up slightly)
const boxYnn = 6; // New Y position for both image boxes

// Left Image Box
doc.rect(10, boxYnn, 30, 35); // Adjusted Left image box (moved slightly up)

// Right Image Box
doc.rect(pageWidth - 40, boxYnn, 30, 35); // Right image box

// Text inside Left Image Placeholder
doc.setFontSize(6); // Set font size for better readability
const placeholderText = [
  "Only ‘Individuals’ to affix",
  "recent photograph",
  "(3.5 cm × 2.5 cm)"
];

let textY = boxYnn + 10; // Adjusted starting Y position for text inside the left box (move up slightly)
placeholderText.forEach((line) => {
  const textWidth = doc.getTextWidth(line);
  const textX = 10 + (30 - textWidth) / 2; // Center text in the 30px wide box
  doc.text(line, textX, textY);
  textY += 3; // Increment Y position for the next line
});

doc.setFontSize(5); // Set font size for better readability
const placeholderText2 = [
  "Signature/Left thumb",
  "impression across this photo"
];

// Position of the horizontal line
const horizontalLineY = boxYnn + 28;  // Adjusted Y position for the horizontal line (move up slightly)
const horizontalLineStartX = 10;  // Starting X position for the line (left side of the box)
const horizontalLineEndX = 40;   // Ending X position for the line (right side of the box)

// Draw the horizontal line above the text
doc.line(horizontalLineStartX, horizontalLineY, horizontalLineEndX, horizontalLineY); // Draw the line

let textYn = boxYnn + 31; // Adjusted starting Y position for text inside the box (move up slightly)
placeholderText2.forEach((line) => {
  const textWidth = doc.getTextWidth(line);
  const textX = 10 + (30 - textWidth) / 2; // Center text in the 30px wide box
  doc.text(line, textX, textYn);
  textYn += 3; // Increment Y position for the next line
});

// Repeat for Right Image Placeholder
textY = boxYnn + 15; // Reset adjusted Y position for right box
placeholderText.forEach((line) => {
  const textWidth = doc.getTextWidth(line);
  const textX = pageWidth - 40 + (30 - textWidth) / 2; // Center text in the 30px wide box
  doc.text(line, textX, textY);
  textY += 3; // Increment Y position for the next line
});

doc.setFontSize(8);
const panText = `Application for Allotment of Permanent Account Number
(In the case of Indian Citizens/Indian Companies/Entities incorporated in India/
Unincorporated entities formed in India)`;
// Center the text on the page
doc.text(panText, pageWidth / 2, 13, { align: 'center' });

  doc.setFontSize(8);
  const panText2= `See Rule 114`;
  const panTextWidth2 = doc.getTextWidth(panText2);
  const panCenterX2 = (pageWidth - panTextWidth2) / 2; // Center the text
  doc.text(panText2, panCenterX2, 23);


  // Instructions with centered text
  doc.setFont('helvetica', 'normal'); 
  doc.setFontSize(6);
  const instructionsText = "To avoid mistake (s), please follow the accompanying instructions and examples before filling up the form";
  const instructionsWidth = doc.getTextWidth(instructionsText);
  const instructionsCenterX = (pageWidth - instructionsWidth) / 2; // Center the text horizontally
  doc.text(instructionsText, instructionsCenterX, 25);

  doc.setFont('helvetica', 'Bold');
  doc.setFontSize(8);
  // Define the text and position
  const aoText = "Assessing officer (AO code)";
  const textX = 41;  // X-coordinate for the text position
  const textRightX = textX + 5;
  const textHeadingY = 27;  // Y-coordinate for the text position
  const textHeightY = textHeadingY + 2;

// Set the background color for the text (e.g., light gray)
doc.setFillColor(230, 230, 230);  // RGB color for light gray background

// Draw a rectangle to serve as the background (with some padding)
const padding = 1; // Padding around the text
const textWidthBg = 129;  // Get the width of the text
const rectHeight = 4;  // Height of the rectangle (adjust as needed)
doc.rect(textX - padding, textHeadingY - padding, textWidthBg + padding * 1, rectHeight + padding * 1, 'F'); // 'F' for fill

// Set the text color (optional, if you want a specific text color)
doc.setTextColor(0, 0, 0);  // Black text color (RGB format)
// Add the text on top of the background rectangle
doc.text(aoText, textRightX, textHeightY);

doc.setFont('helvetica', 'Bold');
doc.setFontSize(8);

// Define positions and sizes
const startX = 45; // Starting X position
const startY = 32; // Starting Y position
const headingBoxWidth = 25; // Width of each heading box
const defaultBoxWidth = 8; // Default small box width (used for 3-box items)
const boxHeightAO = 5; // Height of each box

// Define headings and how many boxes each needs below
const headings = [
  { label: "Area Code", boxCount: 3, fillFullWidth: false },
  { label: "AO Type", boxCount: 2, fillFullWidth: true },
  { label: "Range Code", boxCount: 3, fillFullWidth: false },
  { label: "AO No", boxCount: 2, fillFullWidth: true }
];

// Draw heading boxes with centered text
headings.forEach((item, index) => {
  const boxX = startX + index * headingBoxWidth;
  doc.setTextColor(0, 0, 0);
  doc.rect(boxX, startY, headingBoxWidth, boxHeightAO); // Heading box

  const textWidth = doc.getTextWidth(item.label);
  const textX = boxX + (headingBoxWidth - textWidth) / 2;
  const textY = startY + boxHeightAO / 2 + 1.5;
  doc.text(item.label, textX, textY);
});

// Draw small boxes under each heading
const secondRowY = startY + boxHeightAO;
headings.forEach((item, index) => {
  const boxX = startX + index * headingBoxWidth;
  
  // Determine width and spacing for boxes
  let boxWidth = defaultBoxWidth;
  let spacing = 0;
  let startXBox = boxX;

  if (item.fillFullWidth) {
    // Stretch boxes to fill entire heading box
    boxWidth = headingBoxWidth / item.boxCount;
    spacing = 0;
  } else {
    // Use default width with spacing
    const totalWidth = item.boxCount * boxWidth;
    spacing = (headingBoxWidth - totalWidth) / (item.boxCount + 1);
    startXBox += spacing;
  }

  // Draw boxes
  for (let i = 0; i < item.boxCount; i++) {
    const currentX = item.fillFullWidth
      ? boxX + i * boxWidth
      : startXBox + i * (boxWidth + spacing);
    doc.rect(currentX, secondRowY, boxWidth, boxHeightAO);
  }
});

const aoValues = {
  "Area Code": (formData.AreaCode || "").toString().padEnd(3, " ").substring(0, 3),
  "AO Type": (formData.AoType || "").toString().padEnd(2, " ").substring(0, 2),
  "Range Code": (formData.RangeCode || "").toString().padEnd(3, " ").substring(0, 3),
  "AO No": (formData.AONo || "").toString().padEnd(2, " ").substring(0, 2)
};

// ✅ Fill characters into boxes
headings.forEach((item, index) => {
  const boxX = startX + index * headingBoxWidth;
  const boxY = secondRowY;

  const value = aoValues[item.label]; 
  const chars = value.split("");      

  let boxWidth = defaultBoxWidth;
  let spacing = 0;
  let startXBox = boxX;

  if (item.fillFullWidth) {
    boxWidth = headingBoxWidth / item.boxCount;
  } else {
    const totalWidth = item.boxCount * boxWidth;
    spacing = (headingBoxWidth - totalWidth) / (item.boxCount + 1);
    startXBox += spacing;
  }

  chars.forEach((ch, i) => {
    if (i >= item.boxCount) return; 
    const currentX = item.fillFullWidth
      ? boxX + i * boxWidth
      : startXBox + i * (boxWidth + spacing);

    // Center the text inside each box
    const textX = currentX + boxWidth / 2 - doc.getTextWidth(ch) / 2;
    const textY = boxY + boxHeightAO / 2 + 1.5;
    doc.text(ch, textX, textY);
  });
});

  // Box properties
const boxWidth = 50;  // Width of the box
const boxHeight = 15; // Height of the box
const boxX = pageWidth - 100 + (130 - boxWidth) / 2; // Center the box horizontally
const boxY = textYn + 1; // Position the box below the previous content

// Draw the box at calculated position
doc.rect(boxX, 41, boxWidth, boxHeight); 

// Text properties
const signatureText = "Signature / Left Thumb Impression";
doc.setFontSize(6); // Set font size for the text

// Calculate text dimensions
const textWidth = doc.getTextWidth(signatureText); // Get the width of the text
const textHeight = 2.5; // Approximate height (5% of font size is standard)

// Adjust text position for bottom alignment within the box
const textXright = boxX + (boxWidth - textWidth) / 2; // Center horizontally
const textYright = boxY + boxHeight - textHeight - 2; // Position near the bottom (2 units padding)

// Draw the text inside the box
doc.text(signatureText, textXright, textYright);

// Add the new lines of text below the boxes
const textStartY = 37 + boxHeightAO + 5; // Position below the second row of boxes

// "Sir,"
doc.setFont('helvetica', 'normal');
doc.setFontSize(8); // Adjust font size as needed
doc.text("Sir,", 10, textStartY);

// "I/We hereby request that a permanent account number be allotted to me/us."
const nextTextY = textStartY + 4; // Position for the next line
doc.text("I/We hereby request that a permanent account number be allotted to me/us.", 10, nextTextY);

// "I/We give below necessary particulars"
const finalTextY = nextTextY + 4; // Position for the final line
doc.text("I/We give below necessary particulars", 10, finalTextY);


  // Applicant Details Section
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text = "1. Full Name (Full expanded name to be mentioned as appearing in proof of identity/date of birth/address documents: initials are not permitted)";
  const x = 6;
  const y = 61;
  const fontSize = 7;
  const lineHeight = 0.5;
  const width = 200; // Adjust width as per your requirement
  const height = 5;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x - 1, y - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text, 10, y);

   // Lease Select Title Section Below Full Name
    const leaseSelectTitleX = 20; // Horizontal position of the title
    const leaseSelectTitleY = 66; // Position for the Lease Select Title (below the Full Name section)
  // Draw the "Lease Select Title"
  doc.setFontSize(8); // Set font size for the title
  doc.setFont("helvetica", "normal");
  doc.text("Please select title", 10, 66);

  // Define the starting X and Y position for checkboxes (aligned with the title)
  const checkboxStartX = leaseSelectTitleX + 15; // Starting X position for checkboxes (offset to the right of the title)
  const checkboxY = leaseSelectTitleY - 2; // Adjust Y to align with the title text

  // Size of the checkbox
  const checkboxSize = 4; // Size of the checkbox

  // Offsets for each checkbox (ensure they are placed continuously)
  const checkboxSpacing = checkboxSize + 20; // Spacing between checkboxes (includes space for labels)

  // Function to draw a right tick ✔
  const drawCheckmark = (x, y) => {
    doc.line(x, y + 2, x + 2, y + 4); // bottom line of checkmark
    doc.line(x + 2, y + 4, x + 6, y); // upward slant of checkmark
  };

  // Draw the first checkbox ("as applicable")
  doc.rect(checkboxStartX, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("as applicable", checkboxStartX + checkboxSize + 1, checkboxY + 3); // Label for "as applicable"
  if (formData.ApplicantCheckedOption === "as applicable") {
    drawCheckmark(checkboxStartX, checkboxY);
  }

  // Draw the second checkbox ("Shri")
  const checkboxX2 = checkboxStartX + checkboxSpacing; // Offset X position for next checkbox
  doc.rect(checkboxX2, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Shri", checkboxX2 + checkboxSize + 1, checkboxY + 3); // Label for "Shri"
  if (formData.ApplicantCheckedOption === "Shri") {
    drawCheckmark(checkboxX2, checkboxY);
  }

  // Draw the third checkbox ("Smt")
  const checkboxX3 = checkboxX2 + checkboxSpacing; // Further offset for the next checkbox
  doc.rect(checkboxX3, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Smt", checkboxX3 + checkboxSize + 1, checkboxY + 3); // Label for "Smt"
  if (formData.ApplicantCheckedOption === "Smt") {
    drawCheckmark(checkboxX3, checkboxY);
  }

  // Draw the fourth checkbox ("Kumari")
  const checkboxX4 = checkboxX3 + checkboxSpacing; // Further offset for the next checkbox
  doc.rect(checkboxX4, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Kumari", checkboxX4 + checkboxSize + 1, checkboxY + 3); // Label for "Kumari"
  if (formData.ApplicantCheckedOption === "Kumari") {
    drawCheckmark(checkboxX4, checkboxY);
  }

  // Draw the fifth checkbox ("M/S")
  const checkboxX5 = checkboxX4 + checkboxSpacing; // Further offset for the next checkbox
  doc.rect(checkboxX5, checkboxY, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("M/S", checkboxX5 + checkboxSize + 1, checkboxY + 3); // Label for "M/S"
  if (formData.ApplicantCheckedOption === "M/S") {
    drawCheckmark(checkboxX5, checkboxY);
  }


  // Function to draw a title and a set of aligned boxes
  function drawTitleAndAlignedBoxes(title, titleX, titleY, boxX, boxY, boxCountn, boxWidthn, boxHeightn, inputText,doc,fontSize = 10,
    fontWeight = "normal", yOffset = 0) {

    if (!doc) {
      console.error("jsPDF instance (doc) is undefined!");
      return;
    }

    // Draw the title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8); // Set font size for the title
    doc.text(title, titleX, titleY);

    // Convert inputText to a string safely
    const letters = String(inputText || "").substring(0, boxCountn).split("");
    

    // Set font and font size for box content
    doc.setFont("helvetica", fontWeight);
    doc.setFontSize(fontSize);

    for (let i = 0; i < boxCountn; i++) {
      const currentX = boxX + i * boxWidthn;
      doc.rect(currentX, boxY, boxWidthn, boxHeightn); // Draw box
  
      if (letters[i]) {
        const textX = currentX + boxWidthn / 2 - 1.5;
        const textY = boxY + boxHeightn / 2 + fontSize / 2 - 1 + yOffset;
        doc.text(letters[i], textX, textY); // Apply adjusted Y position
      }
    }
  }

  // Shared variables for box dimensions and alignment
  const boxCountn = 32; // Number of boxes
  const boxWidthn = 5; // Width of each box
  const boxHeightn = 5; // Height of each box
  const boxesStartX = 40; // Fixed starting X position for all boxes
  const titleStartX = 10; // X position for titles

  drawTitleAndAlignedBoxes(
    "Last Name / Surname",
    titleStartX,
    73,
    boxesStartX,
    70,
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.LastName.toUpperCase(),
    doc,
    8,               // 👈 smaller font size
    "normal",          // 👈 bold weight
    -2            // 👈 move text up a bit
  );
  
  drawTitleAndAlignedBoxes(
    "First Name",
    titleStartX,
    78,
    boxesStartX,
    75,
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.FirstName.toUpperCase(),
    doc,
    8,               // 👈 smaller font size
    "normal",          // 👈 bold weight
    -2 
    
  );
  
  drawTitleAndAlignedBoxes(
    "Middle Name",
    titleStartX,
    84,
    boxesStartX,
    80,
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.MiddleName.toUpperCase(),
    doc,
    8,
    "normal",
    -2
  );

  // Function to draw the title and a set of aligned boxes
  function drawTitleAndBoxes(title, titleX, titleY, boxX, boxY, boxCount, boxWidth, boxHeight, text, doc) {
    
    if (!doc) {
      console.error("jsPDF instance (doc) is undefined!");
      return;
    }

    // Draw the title
    doc.setFontSize(8); // Set font size for the title
    doc.text(title, titleX, titleY);

    // Ensure text is safely converted to string and sliced to match boxCount
    const letters = String(text || "").substring(0, boxCount).split("");

     // Draw the boxes and insert letters
   for (let i = 0; i < boxCount; i++) {
    const currentX = boxX + i * boxWidth;
    doc.rect(currentX, boxY, boxWidth, boxHeight); // Draw the box

    // Add letter to the center of the box (if exists)
    if (letters[i]) {
      doc.setFontSize(10);
      doc.text(letters[i], currentX + boxWidth / 2 - 1, boxY + boxHeight / 2 + 3); // Center letter
    }
  }
  }
  
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text2 = "2. Abbreviations of the above name, as you would like it, to be printed on the PAN card";
  const x2 = 6;
  const y2 = 91;
  const width2 = 200; // Adjust width as per your requirement


  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y2 - fontSize * lineHeight, width2, height, "F"); // "F" stands for fill
  doc.text(text2, 10, y2);

    // Shared variables for box dimensions and alignment
  const boxCountPan = 38; // Number of boxes (on each line)
  const boxesStartXPan = 10; // Fixed starting X position for all boxes



  function drawTitleAndBoxes(
    title,
    titleX,
    titleY,
    startX,
    startY,
    boxCount,
    boxWidth,
    boxHeight,
    inputText,
    doc,
    fontSize = 8,
    fontWeight = "normal",
    yOffset = 0
  ) {
    // Set font and size
    doc.setFont("helvetica", fontWeight);
    doc.setFontSize(fontSize);
  
    // Optional title
    if (title) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(title, titleX, titleY);
      doc.setFont("helvetica", fontWeight); // Reset font
      doc.setFontSize(fontSize);            // Reset font size
    }
  
    for (let i = 0; i < boxCount; i++) {
      const currentX = startX + i * (boxWidth + 1);
      doc.rect(currentX, startY, boxWidth, boxHeight); // Draw the box
  
      if (inputText && inputText[i]) {
        doc.text(
          inputText[i],
          currentX + 1.5,
          startY + boxHeight / 2 + fontSize / 2 - 1 + yOffset // vertical adjustment
        );
      }
    }
  }
  drawTitleAndBoxes(
    "",                 // No title
    0,
    0,
    boxesStartXPan,     // X position
    94,                 // Y position for boxes
    boxCountPan,        // 38 boxes
    boxWidthn,
    boxHeightn,
    formData.NewPanName.toUpperCase(), // Text to render
    doc,
    8,                  // Font size
    "normal",           // Font weight
    -2                 // yOffset to move text UP
  );
    
doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text3 = "3. Have you ever been known by any other name?";
  const y3 = 108;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y3 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text3, 10, y3);

  const locationcheckboxYn = 105; // Y position for the checkboxes
  const labelXOffsetn = 2;
  const labelYOffsetn = checkboxSize - 1;
  // Draw the "Father's Name" checkbox and label
  const resiCheckboxX = 90; // X position for the Father's Name checkbox
  doc.rect(resiCheckboxX, locationcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Yes",
    resiCheckboxX + checkboxSize + labelXOffsetn,
    locationcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox

  // Draw the "Mother's Name" checkbox and label
  const officeCheckboxX = 110; // X position for the Mother's Name checkbox
  doc.rect(officeCheckboxX, locationcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "No",
    officeCheckboxX + checkboxSize + labelXOffsetn,
    locationcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox

  // Lease Select Title Section Below Full Name
  const SelectTitleX = 30; // Horizontal position of the title
  const SelectTitleY = 116; // Position for the Lease Select Title (below the Full Name section)
  // Draw the "Lease Select Title"
  doc.setFontSize(8); // Set font size for the title
  doc.setFont("helvetica", "normal");
  doc.text("If yes, please give that other name", 10, 113);

  doc.setFontSize(8); // Set font size for the title
  doc.setFont("helvetica", "normal");
  doc.text("Please select title", 10, 118);

  // Define the starting X and Y position for checkboxes (aligned with the title)
  const checkbox2StartX = SelectTitleX + 5; // Starting X position for checkboxes (offset to the right of the title)
  const checkbox2Y = SelectTitleY - 2; // Adjust Y to align with the title text

  const checkboxSpacingn = 40; // Adjust this value to control the spacing between the checkboxes

  // Draw the first checkbox ("as applicable")
  doc.rect(checkbox2StartX, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("as applicable", checkbox2StartX + checkboxSize + 1, checkbox2Y + 3); // Label for "as applicable"

  // Draw the second checkbox ("Shri")
  const checkboxX2n = checkbox2StartX + checkboxSpacingn; // Offset X position for next checkbox
  doc.rect(checkboxX2n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Shri", checkboxX2n + checkboxSize + 1, checkbox2Y + 3); // Label for "Shri"

  // Draw the third checkbox ("Smt")
  const checkboxX3n = checkboxX2 + checkboxSpacingn; // Further offset for the next checkbox
  doc.rect(checkboxX3n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Smt", checkboxX3n + checkboxSize + 1, checkbox2Y + 3); // Label for "Smt"

  // Draw the fourth checkbox ("Kumari")
  const checkboxX4n = checkboxX3n + checkboxSpacingn; // Further offset for the next checkbox
  doc.rect(checkboxX4n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("Kumari", checkboxX4n + checkboxSize + 1, checkbox2Y + 3); // Label for "Kumari"

  // Draw the fifth checkbox ("M/S")
  const checkboxX5n = checkboxX4n + checkboxSpacingn; // Further offset for the next checkbox
  doc.rect(checkboxX5n, checkbox2Y, checkboxSize, checkboxSize); // Draw the checkbox (empty box)
  doc.text("M/S", checkboxX5n + checkboxSize + 1, checkbox2Y + 3); // Label for "M/S"
 
  doc.setFontSize(6); // Set font size for the title
  doc.setFont("helvetica", "normal");

 // Draw the "Last Name / Surname" title and boxes
 drawTitleAndAlignedBoxes(
  "Last Name / Surname",
  titleStartX,
  124, // Title Y position
  boxesStartX,
  121, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  formData.LastName.toUpperCase(),
  doc,
  8,      // font size inside boxes
  "normal",
  -2
);

// Draw the "First Name" title and boxes
drawTitleAndAlignedBoxes(
  "First Name",
  titleStartX,
  130, // Title Y position
  boxesStartX,
  126, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  formData.FirstName.toUpperCase(),
  doc,
  8,      // font size inside boxes
  "normal",
  -2
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Middle Name",
  titleStartX,
  135, // Title Y position
  boxesStartX,
  131, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  formData.MiddleName.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text4 = "4. Gender (for Individual applicants only) ";
  const y4 = 141;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y4 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text4, 10, y4);

  

  // Define the positions and sizes for the checkboxes
const GendercheckboxYn = 138; // Y position for the checkboxes
const GenderlabelYOffset = checkboxSize - 1; // Offset to align the label text with the checkbox
const GenderlabelXOffset = 2; // Offset for the label text from the checkbox

// Draw the "Male" checkbox and label
const MaleCheckboxX = 75; // X position for the Male checkbox
doc.rect(MaleCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Male",
  MaleCheckboxX + checkboxSize + GenderlabelXOffset,
  GendercheckboxYn + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const FemaleCheckboxX = 95; // X position for thefemale checkbox
doc.rect(FemaleCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Female",
  FemaleCheckboxX + checkboxSize + GenderlabelXOffset,
  GendercheckboxYn + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "Transgender" checkbox and label
const transgenderCheckboxX = 120; // X position for the Transgender checkbox
doc.rect(transgenderCheckboxX, GendercheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Transgender",
  transgenderCheckboxX + checkboxSize + GenderlabelXOffset,
  GendercheckboxYn + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "Photo Mismatch" checkbox and label
const PhotoCheckboxXn = 155; // X position for the label
const PhotoCheckboxYn = 141; // Y position aligned with the Gender checkbox
doc.text("(please tick as applicable)", PhotoCheckboxXn, PhotoCheckboxYn);

// Auto-select Gender based on RepresentativeCheckedOption
if (formData.ApplicantCheckedOption === "Shri") {
  // Shri → Male
  drawCheckmark(MaleCheckboxX, GendercheckboxYn);
} else if (
  formData.ApplicantCheckedOption === "Smt" ||
  formData.ApplicantCheckedOption === "Kumari" ||
  formData.ApplicantCheckedOption === "M/S"
) {
  // Smt / Kumari / M/S → Female
  drawCheckmark(FemaleCheckboxX, GendercheckboxYn);
}

doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text5 = "5. Date of Birth/Incorporation/Agreement/Partnership or Trust Deed/ Formation of Body of individuals or Association of Person";
  const y5 = 147;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y5 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text5, 10, y5);

  const rawDob = String(formatDateToString(formData.Dob) || "");
  const dob = rawDob.replace(/\//g, ""); // Remove all slashes

  const day = dob.slice(0, 2);   // "DD"
  const month = dob.slice(2, 4); // "MM"
  const year = dob.slice(4, 8);  // "YYYY"

  // Shared dimensions and spacing
  const DatelabelYOffset = -2; // Offset to place labels above the boxes
  const DatestartX = 10; // Starting X position for the first label/box group
  const DatestartY = 154; // Starting Y position for the boxes
  const boxSpacing = 5; // Space between each label/box group

  // Draw "Day" label and boxes
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Day", DatestartX, DatestartY + DatelabelYOffset); // Draw the "Day" label above the boxes
  for (let i = 0; i < 2; i++) {
    doc.rect(DatestartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
    if (day[i]) {
      doc.text(day[i], DatestartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
    }
  }

  // Draw "Month" label and boxes
  const MonthStartX = DatestartX + 2 * boxWidthn + boxSpacing; // X position for "Month"
  doc.text("Month", MonthStartX, DatestartY + DatelabelYOffset); // Draw the "Month" label above the boxes
  for (let i = 0; i < 2; i++) {
    doc.rect(MonthStartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
    if (month[i]) {
      doc.text(month[i], MonthStartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
    }
  }

  // Draw "Year" label and boxes
  const YearStartX = MonthStartX + 2 * boxWidthn + boxSpacing; // X position for "Year"
  doc.text("Year", YearStartX, DatestartY + DatelabelYOffset); // Draw the "Year" label above the boxes
  for (let i = 0; i < 4; i++) {
    doc.rect(YearStartX + i * (boxWidthn + 2), DatestartY, boxWidthn, boxHeightn);
    if (year[i]) {
      doc.text(year[i], YearStartX + i * (boxWidthn + 2) + 2, DatestartY + 4);
    }
  }


doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text6 = "6. Details of Parents (applicable only for individual applicants)";
  const y6 = 164;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y6 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text6, 10, y6);

  // Draw the "Lease Select Title"
  doc.setFontSize(8); // Set font size for the title
  doc.setFont("helvetica", "normal");
  doc.text("Whether mother is a single parent and you wish to apply for PAN by furnishing the name of your mother only", 10, 169);


  const parentcheckboxYn = 171; // Y position for the checkboxes

  // Draw the "Father's Name" checkbox and label
  const parentyCheckboxX = 10; // X position for the Father's Name checkbox
  doc.rect(parentyCheckboxX, parentcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Yes",
    parentyCheckboxX + checkboxSize + labelXOffsetn,
    parentcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox

  // Draw the "Mother's Name" checkbox and label
  const parentnCheckboxX = 30; // X position for the Mother's Name checkbox
  doc.rect(parentnCheckboxX, parentcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "No",
    parentnCheckboxX + checkboxSize + labelXOffsetn,
    parentcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox
  
   // Draw the "Lease Select Title"
   doc.setFontSize(8); // Set font size for the title
   doc.setFont("helvetica", "normal");
   doc.text("If yes, please fill in mother’s name in the appropriate space provide below", 10, 179);


   // Draw the "Lease Select Title"
   doc.setFontSize(8); // Set font size for the title
   doc.setFont("helvetica", "bold");
   doc.text("Father’s Name (Mandatory except where mother is a single parent and PAN is applied by furnishing the name of mother only)", 10, 183);

   doc.setFontSize(8); // Set font size for the title
   doc.setFont("helvetica", "normal");
  
   // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
    "Last Name / Surname",
    titleStartX,
    188, // Title Y position
    boxesStartX,
    185, // Boxes Y position
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.FatherLastName.toUpperCase(),
    doc,
    8,                  // Font size
    "normal",           // Font weight
    -2 
  );

  // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
    "First Name",
    titleStartX,
    193, // Title Y position
    boxesStartX,
    190, // Boxes Y position
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.FatherFirstName.toUpperCase(),
    doc,
    8,                  // Font size
    "normal",           // Font weight
    -2 
  );

  // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
      "Middle",
      titleStartX,
      198, // Title Y position
      boxesStartX,
      195, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.FatherMiddleName.toUpperCase(),
      doc,
      8,                  // Font size
    "normal",           // Font weight
    -2 
  );

  // Applicant Details Section
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text(
  "Mother’s Name (optional except where mother is a single parent and PAN is applied by furnishing the name of mother only) ",
  10,
  203
  );

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
    // Draw the "Middle Name" title and boxes
      drawTitleAndAlignedBoxes(
      "Last Name / Surname",
      titleStartX,
      208,// Title Y position
      boxesStartX,
      205, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MotherLastName.toUpperCase(),
      doc,
      8,                  // Font size
    "normal",           // Font weight
    -2 
    );

    // Draw the "Middle Name" title and boxes
    drawTitleAndAlignedBoxes(
    "First Name",
      titleStartX,
      213, // Title Y position
      boxesStartX,
      210, // Boxes Y position
      boxCountn,
      boxWidthn,
      boxHeightn,
      formData.MotherFirstName.toUpperCase(),
      doc,
      8,                  // Font size
    "normal",           // Font weight
    -2 
    );

  // Draw the "Middle Name" title and boxes
  drawTitleAndAlignedBoxes(
    "Middle Name",
    titleStartX,
    218, // Title Y position
    boxesStartX,
    215, // Boxes Y position
    boxCountn,
    boxWidthn,
    boxHeightn,
    formData.MotherMiddleName.toUpperCase(),
    doc,
    8,                  // Font size
    "normal",           // Font weight
    -2 
  );

// Applicant Details Section
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text(
  "Select the name of either father or mother which you may like to be printed on PAN card (Select one only)",
  10,
  223
);

const SelectcheckboxYn = 225; // Y position for the checkboxes

  // Draw the "Father's Name" checkbox and label
  const fatherCheckboxX = 10; // X position for the Father's Name checkbox
  doc.rect(fatherCheckboxX, SelectcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Father’s name",
    fatherCheckboxX + checkboxSize + labelXOffsetn,
    SelectcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox

  // Draw the "Mother's Name" checkbox and label
  const motherCheckboxX = 50; // X position for the Mother's Name checkbox
  doc.rect(motherCheckboxX, SelectcheckboxYn, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Mother’s name",
    motherCheckboxX + checkboxSize + labelXOffsetn,
    SelectcheckboxYn + labelYOffsetn
  ); // Draw the label, aligned with the checkbox

  // Applicant Details Section
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(
  "(Please tick as applicable)",
  80,
  227
  );

// Define the long text string
let applicantText = "(In case no option is provided then PAN card will be issued with father’s name except where mother is a single parent and you wish to apply for PAN by furnishing name of the mother only)";
// Set font and size
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
// Use doc.text() to break the text into multiple lines for better formatting
doc.text(applicantText, 10, 233, { maxWidth: 180 });

doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text7 = "7. Address";
  const y7 = 241;
  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y7 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text7, 10, y7);


  // Define the long text string
  let applicantTextR = "(Residence Addres)";
  // Set font and size
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  // Use doc.text() to break the text into multiple lines for better formatting
  doc.text(applicantTextR, 10, 246);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  const DetailboxesStartX = 63;
  const boxCountb = 27; // Number of boxes


  // Draw the "Middle Name" title and boxes
  drawTitleAndAlignedBoxes(
    "Flat/Room/ Door / Block No",
    titleStartX,
    250, // Title Y position
    DetailboxesStartX,
    247, // Boxes Y position
    boxCountb,
    boxWidthn,
    boxHeightn,
    formData.ResidentRoom.toUpperCase(),
    doc,
    8,                  // Font size
    "normal",           // Font weight
    -2 
  );

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Name of Premises/ Building/Village",
  titleStartX,
  255, // Title Y position
  DetailboxesStartX,
  252, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.ResidentPremises.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Road/Street/ Lane/Post Office",
  titleStartX,
  260, // Title Y position
  DetailboxesStartX,
  257, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.ResidentStreet.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Area / Locality / Taluka / Sub- Division",
  titleStartX,
  265, // Title Y position
  DetailboxesStartX,
  262, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.ResidentArea.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);
// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Town / City / District",
  titleStartX,
  270, // Title Y position
  DetailboxesStartX,
  267, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.ResidentCity.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Shared dimensions and spacing
const startXn = 10; // Starting X position for the first label/box group
const startYn = 280; // Starting Y position for the boxes
// Draw "State / Union Territory" label and box (large box)
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text("State / Union Territory", startXn, startYn + DatelabelYOffset); // Label for State
doc.rect(startXn, startYn, 70, boxHeightn); // Large box for State
doc.text(String(formData.ResidentState || ""), 12, 283.5);

// Draw "Pincode / Zip Code" label and 7 small boxes
const pincodeStartX = startXn + 70 + 0; // Starting X position for Pincode
doc.text("Pincode / Zip Code", pincodeStartX, startYn + DatelabelYOffset); // Label for Pincode
// Ensure the pincode fits into 7 boxes (using padding or truncation)
const pincode = (formData.ResidentPinCode || "").toString().padEnd(7, " ").substring(0, 7);

for (let i = 0; i < 7; i++) { // Keep the 7-box design
  const currentX = pincodeStartX + i * (boxWidthn); // Use original spacing
  doc.rect(currentX, startYn, boxWidthn, boxHeightn); // Draw the 7 boxes
  doc.text(pincode[i], currentX + boxWidthn / 2 - 1, startYn + boxHeightn / 2 + 1); // Center the digits or spaces
}
// Draw "Country Name" label and large box
const countryStartX = pincodeStartX + 7 * (boxWidthn + 0) + 0; // Starting X for Country Name
doc.text("Country Name", countryStartX, startYn + DatelabelYOffset); // Label for Country Name
doc.rect(countryStartX, startYn, 70, boxHeightn); // Large box for Country Name
doc.text("India", countryStartX + 2, startYn + boxHeightn / 2 + 1);

// Add a new page
doc.addPage();
// Draw border on the second page
drawBorder();


// Define the long text string
let officeText = "Office Addres";
// Set font and size
doc.setFont("helvetica", "bold");
doc.setFontSize(8);
// Use doc.text() to break the text into multiple lines for better formatting
doc.text(officeText, 10, 10);
doc.setFont("helvetica", "normal");
doc.setFontSize(8);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Name of office",
  titleStartX,
  14, // Title Y position
  DetailboxesStartX,
  10, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficeName.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);
// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Flat/Room/ Door / Block No",
  titleStartX,
  18, // Title Y position
  DetailboxesStartX,
  15, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficeRoom.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Name of Premises / Building / Village",
  titleStartX,
  23, // Title Y position
  DetailboxesStartX,
  20, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficePremises.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Road/Street/ Lane/Post Office",
  titleStartX,
  28, // Title Y position
  DetailboxesStartX,
  25, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficeStreet.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Area / Locality / Taluka / Sub- Division",
  titleStartX,
  33, // Title Y position
  DetailboxesStartX,
  30, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficeArea.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);
// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Town / City / District",
  titleStartX,
  38, // Title Y position
  DetailboxesStartX,
  35, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.OfficeCity.toUpperCase(),
  doc,
  8,                  // Font size
    "normal",           // Font weight
    -2 
);

const officestartY = 45; // Starting Y position for the boxes
// Draw "State / Union Territory" label and box (large box)
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text("State / Union Territory", startXn, officestartY + DatelabelYOffset); // Label for State
doc.rect(startXn, officestartY, 70, boxHeightn); // Large box for State
doc.text(String(formData.OfficeState || ""), startXn + 1, officestartY + boxHeightn / 2 + 1); // Adjust for vertical centering
// Draw "Pincode / Zip Code" label and 7 small boxes
const pincodeStartXn = startXn + 70 + 0; // Starting X position for Pincode
doc.text("Pincode / Zip Code", pincodeStartXn, officestartY + DatelabelYOffset); // Label for Pincode
// Ensure the pincode fits into 7 boxes (padding or truncation)
const officePincode = (formData.OfficePinCode || "").toString().padEnd(7, " ").substring(0, 7);
// Draw 7 small boxes and input digits
for (let i = 0; i < 7; i++) {
  const currentX = pincodeStartXn + i * (boxWidthn); // Adjust spacing between boxes
  doc.rect(currentX, officestartY, boxWidthn, boxHeightn); // Draw boxes
  doc.text(officePincode[i], currentX + boxWidthn / 2 - 1, officestartY + boxHeightn / 2 + 1);
}
// Draw "Country Name" label and large box
const countryStartXn = pincodeStartXn + 7 * (boxWidthn + 0) + 0; // Starting X for Country Name
doc.text("Country Name", countryStartXn, officestartY + DatelabelYOffset); // Label for Country Name
doc.rect(countryStartXn, officestartY, 70, boxHeightn); // Large box for Country Name
doc.text("India", countryStartXn + 2, officestartY + boxHeightn / 2 + 1.2); // Adjust X and Y for proper positioning

doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text8 = "8. Address for Communication";
  const y8 = 54;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y8 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text8, 10, y8);

  // Define the positions and sizes for the checkboxes
const RcheckboxY = 51; // Y position for the checkboxes

// Draw the "Male" checkbox and label
const RCheckboxX = 60; // X position for the Male checkbox
doc.rect(RCheckboxX, RcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Residence",
  RCheckboxX + checkboxSize + GenderlabelXOffset,
  RcheckboxY + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const FemlaeCheckboxX = 95; // X position for thefemale checkbox
doc.rect(FemlaeCheckboxX, RcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Office",
  FemlaeCheckboxX + checkboxSize + GenderlabelXOffset,
  RcheckboxY + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "Photo Mismatch" checkbox and label
const PhotoCheckboxX = 155; // X position for the label
const PhotoCheckboxY = 54; // Y position aligned with the Gender checkbox
doc.text("(please tick as applicable)", PhotoCheckboxX, PhotoCheckboxY);


  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text9 = "9. Telephone Number & Email ID details";
  const y9 = 59;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y9 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text9, 10, y9);


  // Shared dimensions and spacing
  const CountrystartX = 65; // Starting X position for the first label/box group
  const CountrystartY = 65; // Starting Y position for the boxes

  // Draw "Country Code" label and 3 small boxes
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Country Code", CountrystartX, CountrystartY + DatelabelYOffset);

  const countryCode = "+91".padEnd(3, " ");
    for (let i = 0; i < 3; i++) {
    doc.rect(CountrystartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
    doc.text(countryCode[i] || "", CountrystartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
  }

  // Draw "Area/STD Code" label and 7 small boxes
  const areaStartX = 60 + 3 * (boxWidthn + 5); // Starting X for Area/STD Code
  doc.text("Area/STD Code", areaStartX, CountrystartY + DatelabelYOffset); // Label for Area/STD Code
  const STDCode = String(formData.STDCode || "").padEnd(7, " ");
  for (let i = 0; i < 7; i++) {
    doc.rect(areaStartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
    doc.text(STDCode[i] || "", areaStartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
  }

  // Draw "Telephone/Mobile Number" label and 13 small boxes
  const telStartX = 60 + 7 * (boxWidthn + 5) + 5; // Starting X for Telephone/Mobile Number
  doc.text("Telephone/Mobile Number", telStartX, CountrystartY + DatelabelYOffset); // Label for Telephone/Mobile Number
  const MobileNo = String(formData.MobileNo || "").padEnd(12, " ");
  for (let i = 0; i < 12; i++) {
    doc.rect(telStartX + i * (boxWidthn + 0), CountrystartY, boxWidthn, boxHeightn);
    doc.text(MobileNo[i] || "", telStartX + i * (boxWidthn + 0) + 2, CountrystartY + 4);
  }

  const emailStartX = 10; // Starting X position for the Email ID
  const emailStartY = 74; // Starting Y position for the box
  // Draw "Email ID" label and box
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Email ID", emailStartX, emailStartY + DatelabelYOffset); // Draw the label above the box
  doc.rect(63, 70, 134, 5); // Draw a single box for Email ID
  doc.text(String(formData.EmailId || ""), 65, 74);

doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text10 = "10. Status of applicant";
  const y10 = 79;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y10 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text10, 10, y10);


  // Define the positions and sizes for the checkboxes
  const applicantcheckboxY = 81; // Y position for the checkboxes
  doc.setFont("helvetica", "normal");
  // Draw the "Male" checkbox and label
  const IndividuaCheckboxX = 15; // X position for the Male checkbox
  doc.rect(IndividuaCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
  "Individual",
  IndividuaCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY + GenderlabelYOffset
  ); // Draw the label, aligned with the checkbox

  // Draw the "female" checkbox and label
  const familyCheckboxX = 38; // X position for thefemale checkbox
  doc.rect(familyCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Hindu undivided family",
  familyCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY + GenderlabelYOffset
  ); // Draw the label, aligned with the checkbox

  // Draw the "female" checkbox and label
  const CompanyCheckboxX = 80; // X position for thefemale checkbox
  doc.rect(CompanyCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Company",
    CompanyCheckboxX + checkboxSize + GenderlabelXOffset,
    applicantcheckboxY + GenderlabelYOffset
  ); // Draw the label, aligned with the checkbox

  // Draw the "female" checkbox and label
  const PartnershipCheckboxX = 103; // X position for thefemale checkbox
  doc.rect(PartnershipCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
  doc.text(
    "Partnership Firm",
    PartnershipCheckboxX + checkboxSize + GenderlabelXOffset,
    applicantcheckboxY + GenderlabelYOffset
  ); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const AssociationCheckboxX = 135; // X position for thefemale checkbox
doc.rect(AssociationCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Association of Persons",
  AssociationCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const GovernmentCheckboxX = 175; // X position for thefemale checkbox
doc.rect(GovernmentCheckboxX, applicantcheckboxY, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Government",
  GovernmentCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

const applicantcheckboxY2 = 86; // Y position for the checkboxes

// Draw the "female" checkbox and label
const TrustsCheckboxX = 15; // X position for thefemale checkbox
doc.rect(TrustsCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Trusts",
  TrustsCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY2 + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const BodyCheckboxX = 35; // X position for thefemale checkbox
doc.rect(BodyCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Body of Individuals",
  BodyCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY2 + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const LocalCheckboxX = 70; // X position for thefemale checkbox
doc.rect(LocalCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Local Authority",
  LocalCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY2 + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const ArtificialCheckboxX = 105; // X position for thefemale checkbox
doc.rect(ArtificialCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Artificial Juridical Persons",
  ArtificialCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY2 + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

// Draw the "female" checkbox and label
const LimitedCheckboxX = 150; // X position for thefemale checkbox
doc.rect(LimitedCheckboxX, applicantcheckboxY2, checkboxSize, checkboxSize); // Draw the checkbox
doc.text(
  "Limited Liability Partnership",
  LimitedCheckboxX + checkboxSize + GenderlabelXOffset,
  applicantcheckboxY2 + GenderlabelYOffset
); // Draw the label, aligned with the checkbox

doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text11 = "11. Registration Number (for company, firms, LLPs etc.)";
  const y11 = 94;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y11 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text11, 10, y11);

 // Draw 25 boxes in a single line
let currentX = 10; // Starting X position
const RegistrationboxWidth = 5; // Width of each box
const RegistrationboxHeight = 5; // Height of each box
for (let i = 0; i < 30; i++) {
  doc.rect(currentX, 91 + 5, RegistrationboxWidth, RegistrationboxHeight); // Draw a rectangle
  currentX += RegistrationboxWidth; // Update X position for the next box
}
doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text12 = "12. n case of a person, who is required to quote Aadhaar number or the Enrolment ID of Aadhaar application form as per section 139 AA";
  const y12 = 105;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y12 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text12, 10, y12);

  // Applicant Details Section
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(
    "Please mention your AADHAAR number (if allotted)",
    10,
    110
  );

// Parameters for the boxes
const allottedstartX = 80; // Starting X position (adjust based on spacing from text)
const allottedstartY = 107; // Y position for boxes
const allotteboxWidth = 5; // Width of each box
const allotteboxHeight = 5; // Height of each box

// Ensure the Aadhar EID fits into 12 boxes (padding or truncation)
const aadharEID = (formData.Aadhar_EID || "").toString().padEnd(12, " ").substring(0, 12);

// Draw 12 boxes in a single line
let allottedcurrentX = allottedstartX;
for (let i = 0; i < 12; i++) {
  doc.rect(allottedcurrentX, allottedstartY, allotteboxWidth, allotteboxHeight); // Draw a rectangle
  doc.text(aadharEID[i],allottedcurrentX + allotteboxWidth / 2 - 1,allottedstartY + allotteboxHeight / 2 + 1);
  allottedcurrentX += allotteboxWidth; // Update X position for the next box
}

 // Applicant Details Section
 doc.setFont("helvetica", "normal");
 doc.setFontSize(8);
 doc.text(
   "If AADHAAR number is not allotted, please mention the enrolment ID of Aadhaar application form",
   10,
   115
 );

  const IfallottedstartX = 50; // Starting X position (adjust based on spacing from text)
  const IfallottedstartY = 116; // Y position for boxes

  let IfallottedcurrentXn = IfallottedstartX;
  for (let i = 0; i < 28; i++) {
    doc.rect(IfallottedcurrentXn, IfallottedstartY, allotteboxWidth, allotteboxHeight); // Draw a rectangle
    IfallottedcurrentXn += allotteboxWidth; // Update X position for the next box
  }
  
// Applicant Details Section
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text(
  "Name as per AADHAAR letter or card or as per the Enrolment ID of Aadhaar application form",
  10,
  123
);

// Parameters for the boxes
const EnrolmentstartX = 60; // Starting X position for the boxes
let EnrolmentstartY = 124; // Starting Y position (just below the text)
const boxesPerLine = 26; // Number of boxes per line

// Function to draw a single line of boxes
function drawLineOfBoxes(startX, startY, boxCount) {
  let currentX = startX;
  for (let i = 0; i < boxCount; i++) {
    doc.rect(currentX, startY, allotteboxWidth, allotteboxHeight); // Draw a rectangle (box)
    currentX += allotteboxWidth; // Move to the next box position
  }
}
// Draw 3 lines of boxes
for (let i = 0; i < 3; i++) {
  drawLineOfBoxes(EnrolmentstartX, EnrolmentstartY, boxesPerLine);
  EnrolmentstartY += allotteboxHeight; // Move to the next line directly below
}
doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text13 = "13. Source of Income";
  const y13 = 143;
  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y13 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text13, 10, y13);

  const IncomestartX = 10; // Starting X position
  let IncomestartY = 145; // Starting Y position for the first line
  const IncomelineHeight = 4.5; // Height between lines
  doc.setFont("helvetica", "normal");
  // Function to draw a checkbox with text
  function drawCheckboxWithText(text, x, y) {
    doc.rect(x, y, checkboxSize, checkboxSize); // Draw the checkbox
    doc.text(text, x + checkboxSize, y + checkboxSize - 1); // Add text next to the checkbox
  }
  
  // Line 1: "Salary" and "Capital Gains" checkboxes
  drawCheckboxWithText(" Salary", IncomestartX, IncomestartY);
  drawCheckboxWithText(" Capital Gains", IncomestartX + 150, IncomestartY); // Adjust X for second checkbox
  
  // Line 2: "Income from Other sources"
  IncomestartY += IncomelineHeight; // Move to the next line
  drawCheckboxWithText(" Income from Business / Profession", IncomestartX, IncomestartY);
  drawCheckboxWithText(" Income from Other source", IncomestartX + 150, IncomestartY);
  
  // Line 3: "Income from House property" and "No income"
  IncomestartY += IncomelineHeight; // Move to the next line
  drawCheckboxWithText(" Income from House property", IncomestartX, IncomestartY);
  drawCheckboxWithText(" No income", IncomestartX + 150, IncomestartY); // Adjust X for second checkbox

  const IncomecontentY = 150; // Y position for the content
  // Calculate content width
  const textb = "Business/Profession code";
  const instructionText = "[For Code: Refer instructions]";
  const textWidthb = doc.getTextWidth(textb);
  const instructionWidth = doc.getTextWidth(instructionText);
  const totalWidth = textWidthb + checkboxSize * 2 + instructionWidth + 5;

  // Calculate starting X to center the content
  const startXb = (210 - totalWidth) / 2; // A4 width = 210mm

  // Draw content
  // Draw centered content
  doc.text(textb, startXb, IncomecontentY); // Add main text
  doc.rect(startXb + textWidthb + 5, IncomecontentY - checkboxSize + 1, checkboxSize, checkboxSize); // Draw first small box
  doc.rect(startXb + textWidthb + checkboxSize + 5, IncomecontentY - checkboxSize + 1, checkboxSize, checkboxSize); // Draw second small box
  doc.text(
    instructionText,
    startXb + textWidthb + checkboxSize * 2 + 7,
    IncomecontentY
  ); // Add instruction text

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text14 = "14. Representative Assessee (RA)";
  const y14 = 163;
  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y14 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text14, 10, y14);

  // Applicant Details Section
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text(
  "Full name, address of the Representative Assessee, who is assessible under the Income Tax Act in respect of the person, whose particulars have\n been given in the column 1-13.",
  10,
  168
);
doc.setFont("helvetica", "bold");
doc.setFontSize(8);
const textn = "Full Name (Full expanded name : initials are not permitted)";
const yn = 177;
// Set background color
doc.setFillColor(240, 240, 240); // Light gray background (RGB)
doc.rect(x2 - 1, yn - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
doc.text(textn, 10, yn);

const FullNameTitleX = 30; // Horizontal position of the title
  const FullSelectTitleY = 181; // Position for the Lease Select Title (below the Full Name section)
  doc.setFontSize(8); // Set font size for the title
  doc.setFont("helvetica", "normal");
  doc.text("Please select title", 10, 182);

  // Function to draw a checkmark (✔)
  const drawCheckmark1 = (x, y) => {
    doc.line(x, y + 1, x + 2, y + 3); // bottom-left to center
    doc.line(x + 2, y + 3, x + 6, y - 1); // center to top-right
  };

  // Define the starting X and Y position for checkboxes (aligned with the title)
  const checkboxStartXn = FullNameTitleX + 15; // Starting X position for checkboxes (offset to the right of the title)
  const checkboxYn = FullSelectTitleY - 2; // Adjust Y to align with the title text

  // Draw the first checkbox ("as applicable")
  doc.rect(checkboxStartXn, checkboxYn, checkboxSize, checkboxSize);
  doc.text("as applicable", checkboxStartXn + checkboxSize + 1, checkboxYn + 3);
  if (formData.RepresentativeCheckedOption === "as applicable") {
    drawCheckmark(checkboxStartXn, checkboxYn);
  }

  // Draw the second checkbox ("Shri")
  const checkboxXn = checkboxStartXn + checkboxSpacing;
  doc.rect(checkboxXn, checkboxYn, checkboxSize, checkboxSize);
  doc.text("Shri", checkboxXn + checkboxSize + 1, checkboxYn + 3);
  if (formData.RepresentativeCheckedOption === "Shri") {
    drawCheckmark(checkboxXn, checkboxYn);
  }

  // Draw the third checkbox ("Smt")
  const checkboxXn1 = checkboxXn + checkboxSpacing;
  doc.rect(checkboxXn1, checkboxYn, checkboxSize, checkboxSize);
  doc.text("Smt", checkboxXn1 + checkboxSize + 1, checkboxYn + 3);
  if (formData.RepresentativeCheckedOption === "Smt") {
    drawCheckmark(checkboxXn1, checkboxYn);
  }

  // Draw the fourth checkbox ("Kumari")
  const checkboxXn2 = checkboxXn1 + checkboxSpacing;
  doc.rect(checkboxXn2, checkboxYn, checkboxSize, checkboxSize);
  doc.text("Kumari", checkboxXn2 + checkboxSize + 1, checkboxYn + 3);
  if (formData.RepresentativeCheckedOption === "Kumari") {
    drawCheckmark(checkboxXn2, checkboxYn);
  }

  // Draw the fifth checkbox ("M/S")
  const checkboxXn3 = checkboxXn2 + checkboxSpacing;
  doc.rect(checkboxXn3, checkboxYn, checkboxSize, checkboxSize);
  doc.text("M/S", checkboxXn3 + checkboxSize + 1, checkboxYn + 3);
  if (formData.RepresentativeCheckedOption === "M/S") {
    drawCheckmark(checkboxXn3, checkboxYn);
  }

 
 // Draw the "Last Name / Surname" title and boxes
 drawTitleAndAlignedBoxes(
  "Last Name / Surname",
  titleStartX,
  187, // Title Y position
  boxesStartX,
  184, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  (formData.RepresentativeLastName || "").toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Draw the "First Name" title and boxes
drawTitleAndAlignedBoxes(
  "First Name",
  titleStartX,
  192, // Title Y position
  boxesStartX,
  189, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeFirstName.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Middle Name",
  titleStartX,
  197, // Title Y position
  boxesStartX,
  194, // Boxes Y position
  boxCountn,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeMiddleName.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

doc.setFont("helvetica", "bold");
doc.setFontSize(8);
const textno = "Address";
const yno = 203;
// Set background color
doc.setFillColor(240, 240, 240); // Light gray background (RGB)
doc.rect(x2 - 1, yno - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
doc.text(textno, 10, yno);

doc.setFont("helvetica", "normal");
// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Flat/Room/ Door / Block No",
  titleStartX,
  209, // Title Y position
  DetailboxesStartX,
  205, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeRoom.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Name of Premises/ Building/Village",
  titleStartX,
  214, // Title Y position
  DetailboxesStartX,
  210, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.RepresentativePremises.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Road/Street/ Lane/Post Office",
  titleStartX,
  219, // Title Y position
  DetailboxesStartX,
  215, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeStreet.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Area / Locality / Taluka / Sub- Division",
  titleStartX,
  224, // Title Y position
  DetailboxesStartX,
  220, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeArea.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);
// Draw the "Middle Name" title and boxes
drawTitleAndAlignedBoxes(
  "Town / City / District",
  titleStartX,
  229, // Title Y position
  DetailboxesStartX,
  225, // Boxes Y position
  boxCountb,
  boxWidthn,
  boxHeightn,
  formData.RepresentativeCity.toUpperCase(),
  doc,
  8,
  "normal",
  -2
);

// Shared dimensions and spacing
const addressstartXn = 10; // Starting X position for the first label/box group
const addressstartYn = 235; // Starting Y position for the boxes
// Draw "State / Union Territory" label and box (large box)
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text("State / Union Territory", addressstartXn, addressstartYn + DatelabelYOffset); // Label for State
doc.rect(addressstartXn, addressstartYn, 70, boxHeightn); // Large box for State
doc.text(String(formData.RepresentativeState || ""), 12, 238);

// Draw "Pincode / Zip Code" label and 7 small boxes
const addresspincodeStartX = addressstartXn + 70 + 0; // Starting X position for Pincode
doc.text("Pincode / Zip Code", addresspincodeStartX, addressstartYn + DatelabelYOffset); // Label for Pincode

// Ensure the pincode fits into 7 boxes (using padding or truncation)
const pincode1 = (formData.RepresentativePinCode || "").toString().padEnd(7, " ").substring(0, 7);
// Draw 7 small boxes for Pincode with numbers inside
for (let i = 0; i < 7; i++) {
  const currentX = addresspincodeStartX + i * (boxWidthn); // Adjust spacing if needed
  doc.rect(currentX, addressstartYn, boxWidthn, boxHeightn); // Draw boxes
  doc.text(pincode1[i], currentX + boxWidthn / 2 - 1, addressstartYn + boxHeightn / 2 + 1); 
}

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  const text15 = "15.  Documents submitted as Proof of Identity (POI), Proof of Address (POA) and Proof of Date of Birth (POB)";
  const y15 = 244;

  // Set background color
  doc.setFillColor(240, 240, 240); // Light gray background (RGB)
  doc.rect(x2 - 1, y15 - fontSize * lineHeight, width, height, "F"); // "F" stands for fill
  doc.text(text15, 10, y15);

// Applicant Details Section
doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text(
  "Please refer to the instructions (as specified in Rule 114 of I.T. Rules, 1962) for list of mandatory certified documents to be submitted as applicable.\n[Annexure A, Annexure B & Annexure C are to be used wherever applicable]",
  10,
  260
);

const DocumentsstartLineX = 10; // Starting X position
const DocumentsstartLineY = 249; // Starting Y position
const DocumentstextOffsetY = 0; 
const boxWidthLinen = 65; // Width of the single box
const boxWidthLine = 70; // Width of the single box
const boxHeightLine = 5; // Height of the box

// Function to draw a single box
function drawBox(x, y, width, height) {
  doc.rect(x, y, width, height); // Draw a rectangle (box)
}

// First line: "I/We have enclosed" and box
let DocumentscurrentY = DocumentsstartLineY;
doc.text("I/We have enclosed", DocumentsstartLineX, DocumentscurrentY + DocumentstextOffsetY);
drawBox(DocumentsstartLineX + 28, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box after "I/We"

// Second line: "as proof of identity," and box
DocumentscurrentY += 1; // Move to the next line for better spacing
doc.text("as proof of identity,", 105, DocumentscurrentY + DocumentstextOffsetY);
drawBox(DocumentsstartLineX + 122, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box after text

// Third line: "as proof of date of birth." and box
DocumentscurrentY += 4.5; // Move to the next line for better spacing
doc.text("as proof of address and", DocumentsstartLineX, DocumentscurrentY + DocumentstextOffsetY);
drawBox(DocumentsstartLineX + 32, DocumentscurrentY - 3, boxWidthLinen, boxHeightLine); // Box after text
doc.text("as proof of date of birth.", 110, DocumentscurrentY + DocumentstextOffsetY);


const startLineX = 10; // Starting X position
const startLineY = 271; // Starting Y position
const textOffsetY = -2; // Offset to move text slightly upward

// Function to draw a single box
function drawBox(x, y, width, height) {
  doc.rect(x, y, width, height); // Draw a rectangle (box)
}

// First line: "I/We," and box
let currentY = startLineY;
doc.text("I/We,", startLineX, currentY + textOffsetY);
drawBox(startLineX + 8, currentY - 6, boxWidthLine, boxHeightLine); // Box after "I/We"

// Text "the applicant, in the capacity of" with box
doc.text("the applicant, in the capacity of", startLineX + 1 + boxWidthLine + 10, currentY + textOffsetY);
drawBox(startLineX + 3 + boxWidthLine + 50, currentY - 6, boxWidthLine, boxHeightLine); // Box after text

// Next line: Declaration text
currentY += 3; // Move to the next line
doc.text(
  "do hereby declare that what is stated above is true to the best of my/our information and belief.",
  startLineX,
  currentY
);

doc.setFont("helvetica", "normal");
doc.setFontSize(8);
doc.text(
  "Place",
  10,
  279
);

doc.rect(30, 276, boxWidthLine, boxHeightLine);
// Draw the "Date" label
doc.text("Date", 10, 288); // Inline label before the boxes

const startYdate = 286; // Starting Y position
const labelSpacing = 1; // Space between labels and boxes
let startXdate = 50; // Starting X position for boxes (initial position)

// Custom offset to shift boxes to the right
const xOffset = 20; // Shift boxes by 20 units to the right

// Function to draw labeled boxes
function drawLabeledBoxes(labels, startXdate, startYdate, boxWidthn, boxHeightn) {
  labels.forEach((label, index) => {
    // Calculate X position with additional offset to shift boxes right
    const boxX = startXdate + index * (boxWidthn + 0) + xOffset; // Added xOffset to shift boxes right
    
    // Place label above the box
    doc.text(label, boxX + boxWidthn / 4, startYdate - labelSpacing);
    
    // Draw the box (only once)
    doc.rect(boxX, startYdate, boxWidthn, boxHeightn); // Only one call to draw the box
  });
}
// Labels for date format
const dateLabels = ["D", "D", "M", "M", "Y", "Y", "Y", "Y"];

// Right-side box properties
const marginRight = 7; // Right margin of the PDF
const rightBoxWidth = 65; // Wider box for better text display
const rightBoxHeight = 20; // Smaller height for better alignment
const rightBoxX = pageWidth - rightBoxWidth - marginRight; // Place box to the rightmost side
const rightBoxY = 271; // Align Y position with the starting line

// Draw the labeled date boxes
drawLabeledBoxes(dateLabels, startLineX, startYdate, boxWidthn, boxHeightn);

// Draw the right-side box
drawBox(rightBoxX, rightBoxY, rightBoxWidth, rightBoxHeight);

// Add single-line text inside the right-side box (centered)
doc.text(
  "Signature / Left Thumb Impression of Applicant", 
  rightBoxX + 3, 
  rightBoxY + rightBoxHeight / 1.1 // Center text vertically within the box
);

doc.setFont("helvetica", "normal");
doc.setFontSize(6);
doc.text(
  "Note: As per provisions of Section 272B of the Income Tax Act., 1961, a penalty of ` 10,000 can be levied on possession of more than one PAN.",
  5,
  295
);



// // Draw table with customized styles
// doc.autoTable({
//     startY: startYL,
//     margin: { left: 5 }, // Set left margin to 5px
//     head: headers,
//     body: data,
//     theme: 'grid',
//     styles: {
//         fontSize: 9,
//         textColor: [51, 51, 51], // Dark gray text color for body
//         cellPadding: 2
//     },
//     headStyles: {
//         fillColor: [204, 204, 204], // Light gray background for headers
//         textColor: [0, 0, 0], // Black font color for headers
//         fontStyle: 'normal'
//     },
//     columnStyles: {
//         0: { cellWidth: colWidthsnl[0] }, // Mode
//         1: { cellWidth: colWidthsnl[1] }, // Income-tax Department
//         2: { cellWidth: colWidthsnl[2] }  // Protean
//     }
// });

// Update currentYL for next section
// currentYL = doc.autoTable.previous.finalY + 5;


// Add more pages as needed
// for (let i = 3; i <= 6; i++) {
//   doc.addPage();
//   drawBorder();
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(12);
//   //doc.text(`Page ${i} Title`, centerX, 20); // Example content for each page
// }
  doc.save("New_PAN_Application.pdf");
};

return (
  <>

          <form onSubmit={handleSubmitNewPan}>
               <div className="card card-default">
              <div className="card-header">
                <h2>AO Codes</h2>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="form-group col-md-3">
                    <label htmlFor="AreaCode">Area Code</label>
                    <input type="text" 
                      className="form-control" 
                      name="AreaCode"
                      maxLength={3} 
                      pattern="\d{0,9}"  
                      inputMode="numeric" 
                      value={formData.AreaCode}
                      onChange={handleChange}/>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AoType">AO Type</label>
                    <input type="text" 
                      className="form-control" 
                      name="AoType"
                      maxLength={2} 
                      pattern="\d{0,9}"  
                      inputMode="numeric" 
                      value={formData.AoType}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="RangeCode">Range Code</label>
                    <input type="text" 
                      className="form-control" 
                      name="RangeCode" 
                      maxLength={3} 
                      pattern="\d{0,9}"  
                      inputMode="numeric" 
                      value={formData.RangeCode}
                      onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AONo">AO Code</label>
                    <input type="text" 
                      className="form-control" 
                      name="AONo" 
                      maxLength={2} 
                      pattern="\d{0,9}"  
                      inputMode="numeric" 
                      value={formData.AONo}
                      onChange={handleChange}/>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="State">State</label>
                    <select
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                         className="form-control"
                      >
                        <option value="">Select State</option>
                        {Object.keys(statesAndDistricts).map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="exampleFormControlSelect12">District</label>
                    <select
                        name="district"
                        value={formData.district}
                        onChange={handleChange}
                        disabled={!formData.state}
                         className="form-control"
                      >
                        <option value="">Select District</option>
                        {formData.state &&
                          statesAndDistricts[formData.state].map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                      </select>
                  </div>
                </div>
              </div>
              <div className="border-top"></div>	
              <div className="card-header">
                <div className="row">
                   <div className="col-md-3">
                           <label>Status Of Applicant</label>
                   </div>
                 
                  <div className="col-md-3">
                    <select className="form-control" name="category" onChange={handleCategoryChange}>
                            <option>Select Option  </option>
                            <option>Individual  </option>
                            <option>Trust</option>
                            <option>Hindu Undivided Family</option>
                            <option>Partnership Firm</option>
                            <option>Association Of Person</option>
                            <option>Body Of Individuals</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="card-body">    
              <div className="applicant-section">           
                <div className="form-check d-inline-block mb-3 col-md-2">
                  <input className="form-check-input" 
                   type="radio" 
                   //checked="checked" value="" 
                   name="Shri"
                   checked={formData.ApplicantCheckedOption === "Shri"}
                   onChange={handleCheckboxChange} />
                  <label className="form-check-label" htmlFor="Shri">Shri</label>
                </div>

                <div className="form-check d-inline-block mb-3 col-md-2">
                  <input className="form-check-input" 
                  type="radio" 
                  name="Smt"
                  checked={formData.ApplicantCheckedOption === "Smt"}
                  onChange={handleCheckboxChange}/>
                  <label className="form-check-label" htmlFor="smt">Smt.</label>
                </div>

                <div className="form-check d-inline-block mb-3 col-md-2">
                  <input className="form-check-input" 
                   type="radio" 
                   name="Kumari"
                   checked={formData.ApplicantCheckedOption === "Kumari"}
                   onChange={handleCheckboxChange} />
                  <label className="form-check-label" htmlFor="Kumari">Kumari</label>
                </div>
                <div className="form-check d-inline-block mb-3 col-md-2">
                  <input className="form-check-input" 
                   type="radio" 
                   name="Ms"
                   checked={formData.ApplicantCheckedOption === "Ms"}
                   onChange={handleCheckboxChange} />
                  <label className="form-check-label" htmlFor="ms">Ms</label>
                </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label style={{ lineHeight: '35px' }}>Applicant Name <span style={{ color: "red" }}>*</span></label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Last name"
                       name="LastName" 
                       value={formData.LastName}
                       required
                       onChange={handleChange}
                       
                       />
                       
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="First name"
                       name="FirstName" 
                       value={formData.FirstName}
                       onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Middle name" 
                       name="MiddleName" 
                       value={formData.MiddleName}
                       onChange={handleChange}
                       />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="mname">Name as you would like it, to be printed on the PAN card <span style={{ color: "red" }}>*</span></label>
                      <input type="text" 
                       className="form-control" 
                       placeholder="" 
                       name="NewPanName" 
                       value={formData.NewPanName}
                       required
                       onChange={handleChange}/>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <p>Whether mother is a single parent and you wish to apply for PAN by furnishing the name of your Yes No mother only?(please tick as applicable)</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label style={{ lineHeight: '35px' }}>Father's Name <span style={{ color: "red" }}>*</span></label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Father's Last name" 
                       name="FatherLastName"                         
                       value={formData.FatherLastName}
                       required
                       onChange={handleChange}/>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="First name" 
                       name="FatherFirstName" 
                       value={formData.FatherFirstName}
                       onChange={handleChange}/>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Middle name" 
                       name="FatherMiddleName" 
                       value={formData.FatherMiddleName}
                       onChange={handleChange}/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label style={{ lineHeight: '35px' }}>Mothrer's Name</label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Mother's Last name" 
                       name="MotherLastName" 
                       value={formData.MotherLastName}
                       onChange={handleChange}  />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="First name" 
                       name="MotherFirstName" 
                       value={formData.MotherFirstName}
                       onChange={handleChange}  />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="Middle name" 
                       name="MotherMiddleName" 
                       value={formData.MotherMiddleName}
                       onChange={handleChange}  />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label>Date of Birth / Incorporation <span style={{ color: "red" }}>*</span></label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="input-group mb-3">
                      <input type="date" 
                       className="form-control" 
                       data-mask="00/00/0000" 
                       name="Dob"                        
                       value={formData.Dob}
                       required
                       onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <p style={{fontSize: '90%'}}>ex. DD/MM/YYYY</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                        <label style={{lineHeight: '35px'}}>Contact Details</label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="ISD code" 
                       name="ISDCode"                        
                       value={formData.ISDCode}
                       onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <input type="text" 
                       className="form-control" 
                       placeholder="STD Code" 
                       name="STDCode"                        
                       value={formData.STDCode}
                       onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text mdi mdi-phone" name="basic-addon1" ></span>
                      </div>
                      <input type="text" 
                       className="form-control" 
                       data-mask="(999) 999-9999" 
                       placeholder="Mobile No" 
                       name="MobileNo" 
                       value={formData.MobileNo}
                       required
                       onChange={handleChange}/>
                       
                    </div>
                    <p style={{fontSize: '90%'}}>ex. (999) 999-9999 <span style={{ color: "red" }}>*</span></p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="email">Email address <span style={{ color: "red" }}>*</span></label>
                      <input type="email" 
                       className="form-control" 
                       name="EmailId" 
                       placeholder="Enter Email"                        
                       value={formData.EmailId}
                       required
                       onChange={handleChange}/>
                      <span className="mt-2 d-block">We'll never share your email with anyone else.</span>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="email">Name as per Aadhar <span style={{ color: "red" }}>*</span></label>
                      <input type="text" 
                       className="form-control" 
                       name="AadharName"                       
                       value={formData.AadharName}
                       required
                       onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-3">
                    <label htmlFor="AreaCode">Pan Card Dispatched State</label>
                    <input type="text" 
                     className="form-control" 
                     name="PanDispatchState" 
                     value={formData.PanDispatchState}
                     onChange={handleChange} />
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="AoType">Aadhaar/EID<span style={{ color: "red" }}>*</span></label>
                    <input type="text" 
                     className="form-control" 
                     name="Aadhar_EID" 
                     value={formData.Aadhar_EID}
                     required
                     onChange={handleChange} 
                     maxLength="12" />
                     {errors.Aadhar_EID && <small style={{ color: "red" }}>{errors.Aadhar_EID}</small>}
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="RangeCode">RA Address </label>
                    <input type="text" 
                     className="form-control" 
                     name="RAAddress"                        
                     value={formData.RAAddress}
                     onChange={handleChange}/>
                  </div>
                  {/* <div className="form-group col-md-3">
                    <label htmlFor="State">Proof of Identity</label>
                    <select className="form-control" name="IdentityProof" value={formData.IdentityProof} onChange={handleChange}>
                      <option>select</option>
                      <option>Aadhar card</option>
                      <option>Passport</option>
                      <option>Driving Licence</option>
                      <option>Voter Card</option>
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="exampleFormControlSelect12">Proof of Address</label>
                    <select className="form-control" name="AddressProof" value={formData.AddressProof} onChange={handleChange}>
                      <option>select</option>
                      <option>Aadhar card</option>
                      <option>Passport</option>
                      <option>Voter Card</option>
                      <option>Electricity Bill (Not more than three Moths)</option>
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="exampleFormControlSelect12">Proof of DOB</label>
                    <select className="form-control" name="DobProof" value={formData.DobProof} onChange={handleChange}>
                      <option>select</option>
                      <option>Aadhar card</option>
                      <option>Birth Certificate</option>
                      <option>Passport</option>
                      <option>Voter Card</option>
                    </select>
                  </div> */}
                </div>  
              </div>
              <div className="border-top"></div>				
              <div className="card-header">
                <h2>Address</h2>
              </div>		 
              <div className="card-body">	
                <ul className="nav nav-tabs mb-3" id="pills-tab2" role="tablist">
                  <li className="nav-item">
                    <button className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#nav-tabs-home2" role="tab"
                      aria-controls="nav-tabs" aria-selected="true">
                      Resident</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link" id="nav-profile-tab" data-toggle="pill" href="#nav-profile2" role="tab"
                      aria-controls="nav-profile" aria-selected="false">
                      Office</button>
                  </li>
                </ul>
              <div className="tab-content mt-5" id="nav-tabContent">
                  <div className="tab-pane fade show active" id="nav-tabs-home2" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h5 className="mb-3">Resident Address</h5>
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label htmlFor="AreaCode">Flat/ Room/ Bock No.</label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text" 
                         className="form-control" 
                         name="ResidentRoom"                                                 
                         value={formData.ResidentRoom}
                         maxLength={25}
                         onChange={handleChange}/>
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AoType">Name of premises/ Bldg/ Village </label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text" 
                         className="form-control" 
                         name="ResidentPremises"                                                 
                         value={formData.ResidentPremises}
                         maxLength={25}
                         onChange={handleChange}/>
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="RangeCode">Road/ Street/ Lane/ Post</label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text" 
                         className="form-control" 
                         name="ResidentStreet"                                                 
                         value={formData.ResidentStreet}
                         maxLength={25}
                         onChange={handleChange}/>
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">Area/ Locality/ Taluka</label>
                      </div>
                      <div className="form-group col-md-3">
                        <input type="text" 
                         className="form-control" 
                         name="ResidentArea"      
                        maxLength={25}                                           
                         value={formData.ResidentArea}
                         onChange={handleChange}/>
                      </div>
                      <div className="form-group col-md-3">
                      <label htmlFor="AONo">State/ Union Territory </label>
                      </div>
                      <div className="form-group col-md-3">
                      <select
                        name="ResidentState"
                        value={formData.ResidentState}
                        onChange={handleChange}
                         className="form-control"
                      >
                        <option value="">Select State</option>
                        {Object.keys(statesAndDistricts).map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                      </div>
                      <div className="form-group col-md-3">
                      <label htmlFor="AONo">Town/ City/ District</label>
                        
                      </div>
                      <div className="form-group col-md-3">
                      <select
                        name="ResidentCity"
                        value={formData.ResidentCity}
                        onChange={handleChange}
                        disabled={!formData.ResidentState}
                         className="form-control"
                      >
                        <option value="">Select District</option>
                        {formData.ResidentState &&
                          statesAndDistricts[formData.ResidentState].map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                      </select>
                      
                      </div>
                      
                      
                      <div className="form-group col-md-3">
                        <label htmlFor="AONo">Pin code </label>
                      </div>
                      <div className="form-group col-md-3">
                        <input type= "number" 
                         className="form-control" 
                         name="ResidentPinCode"   
                         nputMode="numeric" 
                         pattern="\d{0,9}"
                         maxLength={6}                                               
                         value={formData.ResidentPinCode}
                         onChange={handleChange}/>
                      </div>
                    </div>
                    {!hideRA && (
                    <div>
                      <h5 className="mb-3">Representative Assessee ( RA )</h5>
                      
                      <div className="row">
                        <div className="col-md-12">
                            <p>Full name. address of the Representative Assessee, who is assessible under the income Tax Act in respect of the person, whose particulars have
                            been given in the column 1-13</p>
                        </div>
                        <div className="representative-section">
                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input" 
                          type="radio" 
                          //checked="checked" 
                          name="Shri"
                          checked={formData.RepresentativeCheckedOption === "Shri"}
                          onChange={handleCheckboxChange} />
                          <label className="form-check-label" htmlFor="Shri"> Shri</label>
                        </div>

                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input" 
                          type="radio" 
                          name="Smt"
                          checked={formData.RepresentativeCheckedOption === "Smt"}
                          onChange={handleCheckboxChange}/>
                          <label className="form-check-label" htmlFor="smt">Smt.</label>
                        </div>

                        <div className="form-check d-inline-block mb-3 col-md-2">
                          <input className="form-check-input" 
                          type="radio" 
                          name="Kumari"
                          checked={formData.RepresentativeCheckedOption === "Kumari"}
                          onChange={handleCheckboxChange} />

                          <label className="form-check-label" htmlFor="Kumari"> Kumari</label>
                        </div>	
                      </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label style={{ lineHeight: '35px' }}>Full Name ( RA )</label>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <input type="text" 
                            className="form-control" 
                            placeholder="Last name" 
                            name="RepresentativeLastName"                                                 
                            value={formData.RepresentativeLastName}
                            onChange={handleChange}/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <input type="text" 
                            className="form-control"  
                            placeholder="First name"  
                            name="RepresentativeFirstName"                                                 
                            value={formData.RepresentativeFirstName}
                            onChange={handleChange}/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <input type="text" 
                            className="form-control" 
                            placeholder="Middle name"  
                            name="RepresentativeMiddleName"                                                 
                            value={formData.RepresentativeMiddleName}
                            onChange={handleChange}/>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-md-3">
                          <label htmlFor="AreaCode">Flat/ Room/ Bock No.</label>
                        </div>
                        <div className="form-group col-md-8">
                          <input type="text" 
                          className="form-control" 
                          name="RepresentativeRoom"                                                 
                              value={formData.RepresentativeRoom}
                              onChange={handleChange}
                              maxLength={25}/>
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="AoType">Name of premises/ Bldg/ Village </label>
                        </div>
                          <div className="form-group col-md-9">
                          <input type="text" 
                          className="form-control" 
                          name="RepresentativePremises"                                                 
                          value={formData.RepresentativePremises}
                          maxLength={25}
                          onChange={handleChange} />
                          
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="RangeCode">Road/ Street/ Lane/ Post</label>
                        </div>
                        <div className="form-group col-md-9">
                          <input type="text" 
                          className="form-control" 
                          name="RepresentativeStreet"                                                 
                          value={formData.RepresentativeStreet}
                          maxLength={25}
                          onChange={handleChange}/>
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="AONo">Area/ Locality/ Taluka</label>
                        </div>
                        <div className="form-group col-md-3">
                          <input type="text" 
                          className="form-control" 
                          name="RepresentativeArea"   
                          maxLength={25}                                              
                          value={formData.RepresentativeArea}
                          onChange={handleChange}/>
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="AONo">State/ Union Territory </label>
                        </div>
                        <div className="form-group col-md-3">
                        <select
                            name="RepresentativeState" 
                            value={formData.RepresentativeState} 
                            onChange={handleChange}
                            className="form-control"
                          >
                            <option value="">Select State</option>
                            {Object.keys(statesAndDistricts).map((state) => (
                              <option key={state} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="AONo">Town/ City/ District</label>
                        </div>
                        <div className="form-group col-md-3">
                        <select
                            name="RepresentativeCity"
                            value={formData.RepresentativeCity}
                            onChange={handleChange}
                            disabled={!formData.RepresentativeState} 
                            className="form-control"
                          >
                            <option value="">Select District</option>
                            {formData.RepresentativeState &&
                              statesAndDistricts[formData.RepresentativeState].map((district) => (
                                <option key={district} value={district}>
                                  {district}
                                </option>
                              ))}
                          </select>
                        </div>
                        
                        <div className="form-group col-md-3">
                          <label htmlFor="AONo">Pin code </label>
                        </div>
                        <div className="form-group col-md-3">
                          <input type= "number" 
                          className="form-control" 
                          name="RepresentativePinCode" 
                          nputMode="numeric" 
                            pattern="\d{0,9}"
                            maxLength={6} 
                          value={formData.RepresentativePinCode}
                          onChange={handleChange}/>
                        </div>  
                      </div>	
                    </div>
                  )}

                  <div className="border-top"></div>
                  <h5 className="mb-3 mt-4">Upload Document</h5>	
                  <div className="row">
                    <div className="col-md-3">
                      <input type="file" 
                       className="form-control" 
                       name="pdfDocument" 
                       accept="application/pdf"
                       required
                       ref={pdfDocumentRef}
                       onChange={handleFileChange} />
                      <p htmlFor="AONo">Form and documents ( PDF only )<span style={{ color: "red" }}>*</span> </p>
                    </div>
                    <div className="col-md-3">
                      <input type="file" 
                       className="form-control" 
                       name="photo" 
                       required
                       accept=".jpg, .png"
                       ref={photoRef}
                       onChange={handleFileChange} />
                      <p htmlFor="AONo">Photo (Jpg and png only) <span style={{ color: "red" }}>*</span></p>
                    </div>
                    <div className="col-md-3">
                      <input type="file" 
                       className="form-control" 
                       name="signature"
                       required
                       accept=".jpg, .png"
                       ref={signatureRef}
                       onChange={handleFileChange} />
                      <p htmlFor="AONo">Signature (Jpg and png only) <span style={{ color: "red" }}>*</span></p>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="nav-profile2" role="tabpanel" aria-labelledby="nav-profile-tab">
                  <h5 className="mb-3">Office Address</h5>
                  <div className="row">
                      <div className="form-group col-md-3">
                        <label htmlFor="AreaCode">Office Name</label>
                      </div>
                      <div className="form-group col-md-9">
                        <input type="text" 
                         className="form-control" 
                         name="OfficeName"
                         value={formData.OfficeName}
                         onChange={handleChange}/>
                      </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="AreaCode">Flat/ Room/ Bock No.</label>
                    </div>
                    <div className="form-group col-md-9">
                      <input type="text" 
                       className="form-control" 
                       name="OfficeRoom"
                       maxLength={25}
                       value={formData.OfficeRoom}
                       onChange={handleChange}/>
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="AoType">Name of premises/ Bldg/ Village </label>
                    </div>
                    <div className="form-group col-md-8">
                      <input type="text" 
                       className="form-control" 
                       name="OfficePremises"
                       value={formData.OfficePremises}
                       onChange={handleChange}
                       maxLength={25} />
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="RangeCode">Road/ Street/ Lane/ Post</label>
                    </div>
                    <div className="form-group col-md-9">
                      <input type="text" 
                       className="form-control" 
                       name="OfficeStreet" 
                       value={formData.OfficeStreet}
                       onChange={handleChange}
                       maxLength={25} />
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="AONo">Area/ Locality/ Taluka</label>
                    </div>
                    <div className="form-group col-md-3">
                      <input type="text" 
                       className="form-control" 
                       name="OfficeArea" 
                       value={formData.OfficeArea}
                       onChange={handleChange}
                       maxLength={25} />
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="AONo">State/ Union Territory </label>
                    </div>
                    <div className="form-group col-md-3">
                    <select
                        name="OfficeState"
                        value={formData.OfficeState}
                        onChange={handleChange}
                         className="form-control"
                      >
                        <option value="">Select State</option>
                        {Object.keys(statesAndDistricts).map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="AONo">Town/ City/ District</label>
                    </div>
                    <div className="form-group col-md-3">
                    <select
                        name="OfficeCity"
                        value={formData.OfficeCity}
                        onChange={handleChange}
                        disabled={!formData.OfficeState}
                         className="form-control"
                      >
                        <option value="">Select District</option>
                        {formData.OfficeState &&
                          statesAndDistricts[formData.OfficeState].map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                      </select>
                    </div>
                    
                    <div className="form-group col-md-3">
                      <label htmlFor="AONo">Pin code </label>
                    </div>
                    <div className="form-group col-md-3">
                      <input type= "number" 
                       className="form-control" 
                       name="OfficePinCode" 
                       nputMode="numeric" 
                         pattern="\d{0,9}"
                         maxLength={6} 
                       value={formData.OfficePinCode}
                       onChange={handleChange}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-footer pt-3 text-center">
              <p>Note: Form Submition Charges Rs.120</p>
                <button type="submit" className="btn btn-primary btn-pill">Submit</button>
              </div>
            </div>	
            </div>
          </form>  
        
  </>

);
};
export default NewPanApplication;
